import script from "./FullscreenLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./FullscreenLoader.vue?vue&type=script&setup=true&lang=js"

import "./FullscreenLoader.vue?vue&type=style&index=0&id=6c57f1a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c57f1a5"]])

export default __exports__